<template>
  <main class="address_search_wrap" :class="{ on: isOpen }">
    <div class="layer_wrap">
      <div ref="dummy2"></div>
      <header class="header">
        <div class="inner">
          <div class="left">
            <button class="h_btn i_back" @click="back_close"></button>
          </div>
          <h1 class="h1">주소찾기</h1>
        </div>
        <div class="search_wrap">
          <div class="search_input">
            <div class="s_input">
              <input
                type="search"
                v-model="searchText"
                placeholder="도로명, 건물명 또는 지번으로 검색"
                @keypress.enter="searchTextSend"
                ref="searchInput"
              />
            </div>
            <div class="s_del" @click="searchTextDel" v-if="isCloseBtn">
              <img
                :src="require(`@/assets/front/images/new/i_x_input.svg`)"
                alt=""
              />
            </div>
            <div class="s_search" @click="searchTextSend">
              <img
                :src="require(`@/assets/front/images/new/i_search_n.svg`)"
                alt=""
              />
            </div>
          </div>
        </div>
      </header>
      <div class="main_con">
        <div ref="dummy3"></div>
        <div class="search_result">
          <div class="list_empty" v-if="list.length == 0">
            <div class="empty_img">
              <img src="@/assets/front/images/new/i_empty.svg" alt="" />
            </div>
            <div class="empty_txt_2" v-if="searchResultText">
              검색한 결과가 없습니다.
            </div>
            <div class="empty_txt_1">
              도로명, 건물명 또는 지번으로 검색해주세요.
            </div>
          </div>
          <div class="search_list" v-if="list.length > 0 && isComplete">
            <div class="list_result" v-if="searchResultText">
              <span>'{{ searchResultText }}'</span> 검색결과
            </div>
            <div class="addr_list">
              <div
                class="addr_txt"
                v-for="(item, index) in list"
                :key="index"
                @click="selectAddress(item.jibunAddr, item.roadAddr)"
              >
                <div class="txt_1" v-if="item.bdNm">{{ item.bdNm }}</div>
                <div class="txt_2">[도로명] {{ item.roadAddr }}</div>
                <div class="txt_3">[지번] {{ item.jibunAddr }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <infinite-loading
        ref="infiniteLoading"
        :direction="direction"
        :identifier="infiniteId"
        @infinite="infiniteHandler"
      >
        <span slot="no-more"></span>
        <span slot="no-results"></span>
        <span slot="spinner"></span>
      </infinite-loading>
    </div>
  </main>
</template>

<script>
import {
  mapActions as addressActions,
  mapGetters as addressGetters,
} from '@common/store/modules/address';
import * as addressTypes from '@common/store/modules/address/types';

import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'addressSearch',
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      isOpen: false,
      searchText: '',
      searchResultText: '',
      page: 1,
      size: 10,
      list: [],
      direction: 'top',
      infiniteId: 0,
      isComplete: false,
      jibunAddr: '',
      roadAddr: '',
    };
  },
  computed: {
    ...addressGetters({
      addressList: addressTypes.ADDRESS_LIST,
    }),
    isCloseBtn() {
      if (this.searchText == '') {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {},
  methods: {
    ...addressActions([addressTypes.SEARCH_ADDRESS_LIST]),
    searchTextDel() {
      this.searchText = '';
      this.$refs.searchInput.focus();
      this.fetchCompleted = false;
    },
    async searchTextSend() {
      if (!this.searchText.trim()) {
        return;
      }
      this.$refs.dummy3.scrollIntoView({ behavior: 'auto' });
      this.searchResultText = this.searchText;
      await this.getListPageOne();
    },
    async getListPageOne() {
      this.direction = 'top';
      this.page = 1;
      this.infiniteId += 1;
    },
    async infiniteHandler($state) {
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        const params = {
          countPerPage: this.size,
          currentPage: this.page,
          keyword: this.searchText,
        };
        this.direction = 'bottom';

        await this[addressTypes.SEARCH_ADDRESS_LIST](params);

        if (this.page == 1) {
          this.list = [];
        }

        console.log('this.addressList');
        console.log(this.addressList);

        if (this.addressList.contents.length) {
          this.list.push(...this.addressList.contents);
          if (this.page == 1) {
            setTimeout(() => {
              this.$refs.dummy3.scrollIntoView({ behavior: 'auto' });
              //window.scrollTo(0, 0);
            }, 100);
          }
          this.page += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      }
      this.isComplete = true;
    },
    async selectAddress(jibunAddr, roadAddr) {
      this.jibunAddr = jibunAddr;
      this.roadAddr = roadAddr;

      await this.$refs.dummy2.scrollIntoView({ behavior: 'smooth' });
      this.$emit('close');
    },
    async back_close() {
      await this.$refs.dummy2.scrollIntoView({ behavior: 'smooth' });
      this.$emit('close');
    },
  },
};
</script>
